// extracted by mini-css-extract-plugin
var _1 = "CalendarGridMonthHead-moduleCalendarGridMonthHead__ypYN2";
var _2 = "CalendarGridMonthHead-moduleweekday__W_Exs";
export { _1 as "CalendarGridMonthHead", _2 as "weekday" }
